import { render, staticRenderFns } from "./navReturn.vue?vue&type=template&id=eb5897d8&scoped=true&"
import script from "./navReturn.vue?vue&type=script&lang=js&"
export * from "./navReturn.vue?vue&type=script&lang=js&"
import style0 from "./navReturn.vue?vue&type=style&index=0&id=eb5897d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb5897d8",
  null
  
)

export default component.exports